<template>
  <div class="width-100">
    <slot name="activator" :on="{ click: openDialog }"> </slot>
    <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="400" width="90%">
      <v-card elevation="0">
        <v-card-text class="position--relative pa-0">
          <div class="guide">
            <h1 v-if="username" :class="{ 'text-small': username.length > 7 }">{{ username }}</h1>
            <p>서명은 신청인 이름 세 글자로 작성해주세요.</p>
          </div>

          <div style="width: 100%; height: 250px">
            <VueSignaturePad
              class="pad"
              ref="signaturePad"
              width="100%"
              :options="{
                onBegin: () => {
                  $refs.signaturePad.resizeCanvas()
                },
              }"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <button @click="clearSign()" class="cancel-btn">취소</button>
          <button @click="saveSign()" class="confirm-btn">확인</button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    username: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    openDialog() {
      this.dialog = true
    },
    saveSign() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      if (isEmpty) {
        this.$swal.basic.alert('사인을 해주세요.')
      } else {
        this.$emit('emitSignSuccess', data)
        this.dialog = false
      }
    },
    undoSign() {
      this.$refs.signaturePad.undoSignature()
    },
    clearSign() {
      this.$refs.signaturePad.clearSignature()
      this.dialog = false
    },
  },
}
</script>
<style lang="scss" scoped>
.guide {
  position: absolute;

  display: flex;
  flex-direction: column;
  justify-content: center;

  width: 100%;
  height: calc(250px - 40px);

  z-index: 1;

  h1 {
    color: #8a94a2;
    font-size: 30px;
    letter-spacing: 20px;
    text-indent: 20px;
    text-align: center;

    margin-bottom: 25px;

    &.text-small {
      font-size: 20px;
    }
  }

  p {
    color: #8a94a2;
    font-size: 14px;
    font-weight: 700;
    text-align: center;

    margin: 0;
  }
}
.pad {
  position: relative;
  z-index: 2;

  -ms-user-select: none;
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}

button {
  outline: none;
  font-size: 18px;
  font-weight: 800;
  margin: 0;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding-top: 1rem;
  padding-bottom: 1rem;
  position: absolute;
  bottom: 0;
  z-index: 3;
}
.cancel-btn {
  color: rgb(114, 125, 140);
  background-color: rgb(215, 225, 234);
  left: 0;
  width: 38.5%;
}
.confirm-btn {
  color: #ffffff;
  background-color: rgb(51, 51, 51);
  right: 0;
  width: 61.5%;
}
</style>
